<template>
    <ul class="article-list">
        <li v-for="(item,index) in dynamicList" :key="index" @click="$router.push({'path':`/celebrity/track/${item.id}`})">
            <img class="fl img" :src="$common.imgPath(item.user.headImg)" />
            <div class="fr info">
                <p class="desc" v-text="$common.interceptStr(item.content,80)">
                </p>
                <p class="time"><i class="el-icon-time"></i>{{item.createTime}}</p>
            </div>

        </li>
    </ul>
</template>
<script>
    export default {
        props:{
            dynamicList:[Array]
        },
        data(){
            return {

            }
        },
        filters:{
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../assets/css/common';
    .article-list{
        padding-bottom:80px;
        li{
            cursor: pointer;
            overflow: hidden;
            padding:24px 21px;
            border-bottom:1px solid #EEEEEE;
            .info{
                width:530px;
                position: relative;
                height:170px;
                .desc{
                    position: absolute;
                    top:15px;
                    left:0;
                    font-size:20px;
                    color:#565656;
                    line-height:31px;
                }

                .time{
                    position: absolute;
                    bottom:10px;
                    left:0;
                    color:#999999;
                    font-size:16px;
                    line-height:42px;
                }
            }
            .img{
                width:170px;
                height:170px;
                background-color:$main-color;
                -webkit-border-radius: 10px;
                -moz-border-radius: 10px;
                border-radius: 10px;
            }

        }
    }
</style>